import axios from 'axios';

/* LOT 47 · Z20 · un appel par donnée et par page : une même lecture (GET) lancée par plusieurs blocs
   au même moment part une seule fois ; toute écriture vide la mémoire. */
const TTL = 1500;
const memo = new Map();

const cle = (c) => {
  const u = axios.getUri(c);
  const auth = (c.headers && (c.headers.Authorization || c.headers.authorization)) || '';
  return `${u}|${auth}|${c.responseType || ''}`;
};

const installerAppelsUniques = () => {
  const base = axios.getAdapter(axios.defaults.adapter);
  axios.defaults.adapter = (config) => {
    const m = (config.method || 'get').toLowerCase();
    if (m !== 'get' || config.responseType === 'blob' || config.responseType === 'arraybuffer' || config.cancelToken) {
      if (m !== 'get' && !/\/fil\/familles\/ranger$/.test(config.url || '')) memo.clear();
      return base(config);
    }
    const k = cle(config);
    const pour = (p) => {
      const sig = config.signal;
      const r = p.then((rep) => ({ ...rep, config }));
      if (!sig) return r;
      if (sig.aborted) return Promise.reject(new axios.CanceledError(null, null, config));
      return new Promise((ok, ko) => {
        const stop = () => ko(new axios.CanceledError(null, null, config));
        sig.addEventListener('abort', stop, { once: true });
        r.then(ok, ko).finally(() => sig.removeEventListener('abort', stop));
      });
    };
    const x = memo.get(k);
    if (x && (x.enCours || Date.now() - x.t < TTL)) return pour(x.p);
    const e = { enCours: true, t: Date.now(), p: null };
    const sansSignal = { ...config };
    delete sansSignal.signal;
    e.p = base(sansSignal).then((r) => { e.enCours = false; e.t = Date.now(); return r; }, (err) => { memo.delete(k); throw err; });
    memo.set(k, e);
    if (memo.size > 300) memo.delete(memo.keys().next().value);
    return pour(e.p);
  };
};

installerAppelsUniques();
